/// <reference types="vite/client" />
// Vite entrypoint for the third-party embed script.
//
// The embed runs on partner sites — there's no <link rel="stylesheet"> to load
// our CSS, so we inline the stylesheet into the JS bundle via `?inline` and
// inject it at runtime. Similarly, the two SVGs referenced from embed.scss use
// `url(...?inline)` so they're base64-inlined into the CSS string rather than
// emitted as separate files.
//
// **IMPORTANT**
// Vite-produced JS usually has to be included with a <script type="module">
// tag. Since we have embeds out in the wild that do not include type="module"
// this is not an option. However, since this entrypoint is so small that vite
// does not do any chunking, it does not currently matter. If at any point vite
// decides to chunk, embeds will break. Our system specs will notice that, since
// they do test the script without type="module" as well.

import { VideoEmbed } from 'embed/javascripts/video_embed'
import embedStyles from 'embed/stylesheets/embed.scss?inline'

const styleEl = document.createElement('style')
styleEl.textContent = embedStyles
document.head.appendChild(styleEl)

VideoEmbed.embedAll()
